import { Trans, useLingui } from '@lingui/react/macro';
import { Box, Button, Link, Typography } from '@mui/material';
import { BaseDialog, type DialogKey, useDialogStore } from '@/components/dialogs';
import useAuthStore from '../../../store/rootStore.ts';

const DIALOG_KEY: DialogKey = 'geoBlockDialog';
const COUNTRIES_WITH_IMAGES = new Set(['us', 'by', 'ir', 'ru', 'gb', 'cu', 'kp', 'sy', 'ua']);

const imageContainerSx = {
  textAlign: 'center',
  mb: 2,
  borderRadius: 1,
  overflow: 'hidden',
  border: `1px solid var(--mui-palette-primary-main)`,
  maxWidth: '200px',
  marginX: 'auto',
};

export const GeoBlockDialog = () => {
  const { t } = useLingui();
  const isOpen = useDialogStore((state) => !!state.openDialogs[DIALOG_KEY]);
  const dialogData = useDialogStore((state) => state.getDialogData('geoBlockDialog'));
  const closeDialog = useDialogStore((state) => state.closeDialog);
  const termsOfUseUrl = useAuthStore((s) => s.config?.features.termsOfUseUrl);

  if (!isOpen) return null;

  const rawCode = dialogData?.countryCode ?? 'us';
  const countryCode = COUNTRIES_WITH_IMAGES.has(rawCode) ? rawCode : 'us';
  const imageSrc = `/assets/${countryCode}-blocked.png`;

  return (
    <BaseDialog
      dialogKey={DIALOG_KEY}
      title={t`You're protected`}
      onSubmit={() => closeDialog(DIALOG_KEY)}
      paperMaxWidth={400}
      actions={
        <Button type="submit" variant="contained" size="large" fullWidth>
          <Trans>Accept</Trans>
        </Button>
      }
    >
      <Box sx={imageContainerSx}>
        <img src={imageSrc} alt={t`Unavailable in your location`} style={{ maxWidth: '100%', height: 'auto' }} />
      </Box>
      <Typography variant="body1" sx={{ mb: 2 }}>
        <Trans>
          Sorry, the Perpl front end is not available in your current location. Users from{' '}
          <Link href={termsOfUseUrl} target="_blank" rel="noopener noreferrer" underline="always">
            Restricted Territories
          </Link>{' '}
          cannot use the platform.
        </Trans>
      </Typography>
      <Typography variant="body1">
        <Trans>Thank you for your understanding.</Trans>
      </Typography>
    </BaseDialog>
  );
};
